import React from 'react';
import { X, Layers, Package, Unlink } from 'lucide-react';
import EstadoBadge from './EstadoBadge';

export default function ConsolidadoDetalleModal({ consolidacion, onClose, onDesconsolidar }) {
  const paquetes = consolidacion.paquetes || [];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Layers size={18} /> {consolidacion.guia_agrupada || 'Paquete consolidado'}
          </h3>
          <button className="btn-ghost" onClick={onClose}><X size={18} /></button>
        </div>

        <p className="text-secondary text-sm" style={{ marginBottom: 'var(--spacing-4)' }}>
          Este grupo contiene {paquetes.length} paquete{paquetes.length !== 1 ? 's' : ''} individuales.
        </p>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Guía / Tracking</th>
                <th>Descripción</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {paquetes.map((p) => (
                <tr key={p.id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Package size={14} style={{ color: 'var(--color-text-secondary)', flexShrink: 0 }} />
                      <div>
                        <div>{p.tracking}</div>
                        {p.guia && <div className="text-xs text-secondary">{p.guia}</div>}
                      </div>
                    </div>
                  </td>
                  <td className="text-sm">{p.descripcion || '—'}</td>
                  <td><EstadoBadge estado={p.estado_actual_detalle} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="modal-actions" style={{ marginTop: 'var(--spacing-4)' }}>
          {onDesconsolidar && (
            <button className="btn-ghost" onClick={onDesconsolidar} style={{ marginRight: 'auto' }}>
              <Unlink size={14} /> Desconsolidar
            </button>
          )}
          <button className="btn-secondary" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}
